module.exports = __webpack_public_path__ + "img/Bank Artha Graha.c619958b.png";